
const Footer = () => {
    return (
        <footer className="footer mt-auto w-full pt-2">
            <p className="text-red-900 italic tracking-[6px] pb-[8px]">Copyright © {new Date().getFullYear()} XXZCUZX. All rights reserved.</p>
        </footer>
    );
}

export default Footer;